import React from 'react'
import { Helmet } from 'react-helmet';
import utils from '../../utils';
import ResetPasswordForm from '../../components/auth/PasswordChangeForm';

function ForgotPassword() {
    const url = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <div>
            <Helmet>
                <title>Reset Password - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>
            <main>
                <div className="flex flex-col md:flex-row min-h-[calc(100vh-60px)]">
                    <div className="relative w-full md:w-1/2 split-bg min-h-[300px] md:min-h-0 flex flex-col justify-center items-center p-8 md:p-12 lg:p-16">
                        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                        <div className="relative z-1 text-center text-white">
                            <h2 className="text-4xl md:text-5xl font-black text-white">Account Recovery</h2>
                            <div className="mt-6 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 flex items-center justify-center bg-white dark:bg-slate-900 md:p-5 lg:p-7">
                        <ResetPasswordForm/>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ForgotPassword